var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { ChromePicker } from 'react-color';
import Styled from 'styled-components';
import { Icon } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
export var LabelIcon = withStyles({
    root: {
        cursor: 'pointer',
        color: '#757575',
    },
})(Icon);
export var SearchField = withStyles({
    root: {
        width: '80%',
        marginBottom: 0,
    },
})(TextField);
export var useStyles = makeStyles(function (theme) { return ({
    paper: {
        position: 'absolute',
        zIndex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: 236,
    },
    container: {
        padding: '0px',
    },
    labelItem: {
        display: 'flex',
        justifyContent: 'space-between',
        width: 215,
        alignItems: 'center',
    },
    colorPreview: {
        display: 'flex',
        height: 10,
        width: 10,
        background: 'azure',
        borderRadius: 10,
        margin: 10,
    },
    labelName: {
        color: '#000 !important',
        marginLeft: 15,
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
    createLabel: {
        width: '100%',
        padding: 15,
        textAlign: 'center',
        borderTop: '1px solid #979797',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    button: {
        margin: '0px 10px 15px 10px',
        boxShadow: 'none',
    },
    header: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        padding: '10px 25px 0px 25px',
    },
    iconContainer: {
        background: '#D8D8D8',
        width: 40,
        height: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 20,
    },
    editIcon: {
        top: '8px',
        left: '4px',
        cursor: 'pointer',
    },
    buttonAction: {
        cursor: 'pointer',
        margin: '0px 10px',
    },
}); });
export var ColorPicker = Styled(ChromePicker)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 190px !important;\n    box-shadow: none !important;\n"], ["\n    width: 190px !important;\n    box-shadow: none !important;\n"])));
var templateObject_1;
//# sourceMappingURL=style.js.map